module.exports = __webpack_public_path__ + "static/media/icon_149.268b3b85.svg";